import { useQuery } from "@tanstack/react-query";
import { fetchFundingTerms } from "@/api/campaigns";

/**
 * The caller's organisation's funding terms for Step 4: the pay-as-you-give deposit percentage and
 * size floors, and whether (and on what terms) it may launch postpaid. A preview — launch resolves
 * and re-checks all of it — so it is fetched once and kept fresh for a minute.
 */
export function useFundingTerms(enabled = true) {
  return useQuery({
    queryKey: ["funding-terms"],
    queryFn: fetchFundingTerms,
    enabled,
    staleTime: 60_000,
  });
}
